import { User } from "../@core/data/users";
import { Person } from "./person.model";

export class Project {
  id?: string;
  title?: string;
  description?: string;
  why?: string;
  how?: string;
  what?: string;
  purpose?: string;
  startDate?: Date;
  endDate?: Date;
  rules?: string;
  budget?: number;
  tags?: string[];

  coverUrl?: string;
  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images
  isDefault?: boolean;

  //List contacts
  members?: ProjectMembers[];

  shopId?: string;
  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class ProjectMembers {
  id?: string;
  role?: string;
  description?: string;
  person?: Person;

  //default
  timestamp?: number;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}
